export function Logo({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" aria-hidden="true">
      <rect x="2" y="6" width="24" height="18" rx="5" fill="#B5532B" />
      <path d="M2 11h24" stroke="#F8F3EA" strokeWidth="2" />
      <circle cx="20" cy="17" r="2.2" fill="#F8F3EA" />
    </svg>
  );
}
